import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import EzSuperFormControlLabelMui from "./Implementations/EzSuperFormControlLabelMui.es.js";
const EzSuperFormControlLabel = forwardRef(
  ({ checked, control, disabled = false, icon, label, value }, ref) => /* @__PURE__ */ jsx(
    EzSuperFormControlLabelMui,
    {
      checked,
      control,
      disabled,
      icon,
      label,
      value,
      ref
    }
  )
);
EzSuperFormControlLabel.displayName = "EzSuperFormControlLabel";
export {
  EzSuperFormControlLabel as default
};
//# sourceMappingURL=EzSuperFormControlLabel.es.js.map
